/**
 * 定额管理路由
 */
const RefundReportRouter = {
  path: 'refundReport',
  name: 'RefundReport',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/RefundReport/index')
}
export default RefundReportRouter
